import React, { useEffect, useState } from "react";
/* Components */
import Button from "../button/button";
import { useMutation } from "react-query";
import { useForm } from "react-hook-form";
import { updatePassword } from "../../services/auth.service";
import { useLocation, useNavigate } from "react-router-dom";
import useSnackbarStore from "../../store/snackbarStore";
import { useMixPanel } from "../../hooks/useMixPanel";
import { useTranslation } from "react-i18next";
import useSessionStore from '../../store/useSessionStore';

const ChangePassForm = () => {
  const [loading, setLoading] = useState(false);
  const { show } = useSnackbarStore();
  const { setInitialEvent } = useMixPanel();
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const { setUser } = useSessionStore();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const password = watch("password");

  useEffect(() => {
    if (!token) {
      show("Token invalido");
      navigate("/");
    }
    // eslint-disable-next-line
  }, []);
  console.log("token ", token);
  const mutation = useMutation(updatePassword, {
    onSuccess: (data) => {
      localStorage.setItem("token",data?.access_token);
      localStorage.setItem("user",JSON.stringify(data?.user))
      setUser(data?.user);
      setInitialEvent(data, "SHAIA_CHANGE_PASSWORD");
      show(t("clave_actualizada"));
      navigate("/");
      setLoading(false);
    },
    onError: (error) => {
      show(t("error_general"), "error");

      setLoading(false);
    },
  });

  const onSubmit = (form) => {
    setLoading(true);
    mutation.mutate({ password: form.password, token });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <h2 className="alt-h1">{t("cambiar_contrasena")}</h2>
      <div className="input-text mt-2">
        <label className="input-label">{t("new_password")}:</label>
        <input
          className="input-box"
          type="password"
          {...register("password", { required: t("requiredPassword") })}
        />
        {errors.password && (
          <span className="error">{errors.password.message}</span>
        )}
      </div>
      <div className="input-text">
        <label className="input-label">{t("confirm_password")}:</label>
        <input
          className="input-box"
          type="password"
          {...register("confirmPassword", {
            required: t("requiredPassword"),
            validate: (value) => value === password || t("Claves no coinciden"),
          })}
        />
        {errors.confirmPassword && (
          <span className="error">{errors.confirmPassword.message}</span>
        )}
      </div>
      <p className="password-advice">{t("advice_password")}</p>
      <div className="form-CTA">
        <Button
          label={loading ? `${t("boton_actualizando")} ...` : t("boton_actualizar")}
          variant="primary"
          typeB="submit"
        />
      </div>
    </form>
  );
};

export default ChangePassForm;
